import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  useMediaQuery,
  useTheme,
  Box,
} from "@mui/material";
import { TransactionList } from "../TransactionList";
import type { GetTransactionsQueryDto, InvoiceId } from "../../api/types";

interface InvoiceTransactionsModalProps {
  invoiceId: InvoiceId | null;
  open: boolean;
  onClose: () => void;
}

export const InvoiceTransactionsModal = ({
  invoiceId,
  open,
  onClose,
}: InvoiceTransactionsModalProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  if (!invoiceId) return null;

  // Use a fixed filter for the given invoice.
  // We use a high limit to ensure we see all transactions for the invoice without pagination for now.
  const filters: GetTransactionsQueryDto = {
    startDate: null,
    endDate: null,
    source: null,
    group: null,
    category: null,
    merchant: null,
    description: null,
    autoTransactionId: null,
    importId: null,
    ignored: null,
    invoice: [invoiceId],
    limit: 100,
    cursor: null,
    sort: "dateDesc",
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={isMobile}
      maxWidth="lg"
      fullWidth
    >
      <DialogTitle>Invoice Transactions</DialogTitle>
      <DialogContent dividers sx={{ p: isMobile ? 1 : 2 }}>
        <Box sx={{ width: "100%" }}>
          <TransactionList filters={filters} />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};
